export default __webpack_public_path__ + "static/media/danger-chat-ill.eccc8e40.png";